import { AnyAction } from "redux";

import {
  SLIDE_DETAIL_REQUEST,
  SLIDE_RANGE_MANIFEST_REQUEST,
  SLIDE_RANGE_MANIFEST_SUCCESS,
  SLIDE_TILES_LOADED,
  WIPE_SLIDE_DETAIL,
} from "../actions/constants";

export interface DeepZoomOutput {
  TileSize: number;
  Overlap: number;
  Format: "jpeg" | "avif";
  Size: {
    Width: number;
    Height: number;
  };
  Original_Size: {
    Width: number;
    Height: number;
  };
  Offset: {
    Width: number;
    Height: number;
  };
}

export interface RangeManifest extends DeepZoomOutput {
  Levels: {
    [key: number]: {
      [key: string]: string;
    };
  };
  EffectiveMagnification?: number;
  ObjectiveMagnification?: number;
}

export interface SlideTileState {
  tiles_loaded: boolean;
  range_manifest?: RangeManifest;
}

export const initialState: SlideTileState = {
  tiles_loaded: false,
  range_manifest: undefined,
};

const reducer = (state: SlideTileState = initialState, action: AnyAction) => {
  switch (action.type) {
    case SLIDE_RANGE_MANIFEST_REQUEST:
    case SLIDE_DETAIL_REQUEST:
    case WIPE_SLIDE_DETAIL: {
      return { ...initialState };
    }
    case SLIDE_TILES_LOADED: {
      return {
        ...state,
        tiles_loaded: action.payload,
      };
    }
    case SLIDE_RANGE_MANIFEST_SUCCESS:
      return {
        ...state,
        range_manifest: action.payload.response as RangeManifest,
      };
    default:
      return state;
  }
};

export default reducer;
